/**
 * Bridge scratch-gui to Nexus theme-sync.js (--theme-* CSS variables).
 * Editor dark mode (TurboWarp toggle) must stay in sync with shell chrome.
 */

const EDITOR_DARK_TOKENS = {
    '--theme-bg': '#141418',
    '--theme-glass-tint': 'rgba(14, 22, 32, 0.72)',
    '--theme-glass-border': 'rgba(255, 255, 255, 0.08)',
    '--theme-text-primary': '#f1f5f9',
    '--theme-text-secondary': '#94a3b8',
    '--theme-accent': '#818cf8',
    '--theme-gradient': 'linear-gradient(135deg, rgba(102, 126, 234, 0.92) 0%, rgba(118, 75, 162, 0.92) 100%)'
};

const applyEditorDarkTokens = () => {
    const doc = document.documentElement;
    for (const [name, value] of Object.entries(EDITOR_DARK_TOKENS)) {
        doc.style.setProperty(name, value);
    }
};

/**
 * @param {boolean} isEditorDark TurboWarp gui dark mode active
 */
const applyNexusShellTheme = isEditorDark => {
    const doc = document.documentElement;
    const nexusShellDark = localStorage.getItem('nexus_dark_mode') === 'true';
    const effectiveDark = Boolean(isEditorDark) || nexusShellDark;

    doc.setAttribute('data-editor-dark', isEditorDark ? 'true' : 'false');

    if (typeof window !== 'undefined' && window.NexusApplyTheme) {
        window.NexusApplyTheme(localStorage.getItem('nexus_theme') || 'default');
    }

    // theme-sync follows nexus_dark_mode only — override when TurboWarp dark is on alone
    doc.setAttribute('data-dark-mode', effectiveDark ? 'true' : 'false');
    if (document.body) {
        document.body.setAttribute('data-dark-mode', effectiveDark ? 'true' : 'false');
    }

    if (isEditorDark && !nexusShellDark) {
        applyEditorDarkTokens();
    }
};

const onNexusShellThemeChange = callback => {
    const handler = e => {
        if (!e.key || e.key.startsWith('nexus_') || e.key === 'tw:theme') {
            callback();
        }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
};

export {
    applyNexusShellTheme,
    onNexusShellThemeChange
};
